import { createAsyncThunk } from '@reduxjs/toolkit';
import { ACTIONS_PREFIX } from '../constants';

const sendConnectRequest = createAsyncThunk(
	`${ACTIONS_PREFIX}/sendConnectRequest`,
	async (args = {}, { extra }) => {
		const { api } = extra;
		const { message } = args;

		await api.apiNest.post('claims/telegram', {
			data: { message },
		});
	},
);

export default {
	action: sendConnectRequest,
};
